module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/persional-application-lock.0dc54e3b.png";